import { z } from "zod";

export const SyncPermissionsSchema = z.object({
    permissions: z.array(z.string())
});

export type SyncPermissionsFormData = z.infer<typeof SyncPermissionsSchema>;